import { Component, OnInit, ViewChild, ElementRef, AfterViewInit , ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GmNoteService } from 'src/app/services/gm-note.service';

@Component({
    selector: 'app-create-note',
    templateUrl: './create-note.component.html',
    styleUrls: ['./create-note.component.scss'],
    standalone: false
})
export class CreateNoteComponent implements OnInit, AfterViewInit {

    @ViewChild('noteTextarea') noteTextarea!: ElementRef;
    privateNoteForm: FormGroup;
    userId: string | number = '';
    game_id: string | number = '';
    noteType: 'private' | 'public' = 'private'; // Note type passed from parent

    constructor(private formBuilder: FormBuilder, private activeModal: NgbActiveModal,
        private gmNoteService: GmNoteService, private cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.privateNoteForm = this.formBuilder.group({
            note: ['', Validators.required]
        });
    }

    ngAfterViewInit(): void {
        // Set focus on the textarea after the view is initialized
        if (this.noteTextarea) {
            setTimeout(() => {
                this.noteTextarea.nativeElement.focus();
            }, 0);
        }
    }



    closeForm() {
        this.activeModal.close(false);
    }

    createNote() {
        if (this.privateNoteForm.invalid) {
            this.privateNoteForm.get('note').markAllAsTouched();
            return;
        }
        const notePayload = {
            game: this.game_id,
            is_private: this.noteType === 'private',
            text: this.privateNoteForm.get('note').value,
        };

        this.gmNoteService.createNote(this.userId, notePayload).subscribe({
            next: (data: any) => {
                if (data) {
                    this.cdr.detectChanges();
                    this.activeModal.close({ action: "created" });
                } else {
                    console.error('Error creating note:', data.error);
                }
            },
            error: (err) => {
                console.error('Error creating note:', err);
            
          this.cdr.detectChanges();},
        });
    }

}
